"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette, _theme$palette2, _theme$palette3, _theme$palette4;
  return {
    cartOverlay: {
      "& .mco-shop-cart-buttons": {
        background: (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.grey) === null || _theme$palette === void 0 ? void 0 : _theme$palette[50],
        [theme.breakpoints.up("sm")]: {
          "& button": {
            flex: 1
          }
        }
      },
      "& .mco-shop-cart-price": {
        background: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 || (_theme$palette2 = _theme$palette2.grey) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2[50],
        borderBottom: "1px solid ".concat((_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 || (_theme$palette3 = _theme$palette3.grey) === null || _theme$palette3 === void 0 ? void 0 : _theme$palette3[100]),
        padding: theme.spacing(2),
        [theme.breakpoints.up("md")]: {
          padding: theme.spacing(3)
        }
      },
      "& .mco-shop-cart-total-price": {
        paddingBottom: theme.spacing(4)
      },
      "& .mco-shop-price__value": {
        marginRight: 0
      },
      "& .mco-shop-price__original": {
        marginRight: 0
      },
      "& .mco-shop-cart-error": {
        marginTop: theme.spacing(2)
      },
      "& .mco-shop-cart-error__svg-wrapper": {
        "& svg": {
          maxWidth: 180
        }
      }
    },
    paper: {
      background: "#FFFFFF",
      maxWidth: 550,
      width: "100%",
      zIndex: theme.zIndex.modal + 10
    },
    content: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      padding: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3)
      }
    },
    sticky: {
      background: (_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 || (_theme$palette4 = _theme$palette4.grey) === null || _theme$palette4 === void 0 ? void 0 : _theme$palette4[50],
      bottom: 0,
      position: "sticky",
      padding: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3)
      }
    }
  };
});
var _default = exports.default = styles;